import {
  Box,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import { colors, theme } from "../../theme/theme";

const CustomDropdown = ({
  value,
  setValue,
  data = [],
  label,
  mT,
  width,
  color,
  placeholder,
  noIcon,
  Icon,
  borderColor,
  placeholderColor,
}) => {
  return (
    <Box sx={{ width: width, mt: mT || 0 }}>
      {label && (
        <Typography
          sx={{
            fontFamily: "Mulish-Regular",
            fontSize: "12px",
            color: colors.textColor,
            fontWeight: "700",
            mb: 0.5,
            textTransform: "uppercase",
            textAlign: "left",
          }}
        >
          {label}
        </Typography>
      )}
      <FormControl fullWidth>
        <Select
          value={data?.find((item) => item.value === value)?.label || ""}
          onChange={(e) => setValue(e.target.value)}
          displayEmpty
          sx={{
            color: value ? color || "#fff" : color || "rgba(255,255,255,0.5)",
            borderRadius: "8px",
            ".MuiOutlinedInput-notchedOutline": {
              border: theme.lightBorder,
              borderColor: borderColor || theme.lightBorder,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: theme.lightBorder,
              borderColor: borderColor || theme.lightBorder,
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: theme.lightBorder,
              borderColor: borderColor || theme.lightBorder,
            },
            "& .MuiSelect-icon": {
              color: color || "rgba(255,255,255,0.5)",
            },
          }}
          renderValue={(selected) => {
            if (!selected) {
              return (
                <span
                  style={{ color: placeholderColor || "rgba(25,34,52,0.5)" }}
                >
                  {placeholder || "Select"}
                </span>
              );
            }
            return selected;
          }}
        >
          {data?.map((option) => (
            <MenuItem
              style={{
                textTransform: "capitalize",
              }}
              key={option.value}
              value={option.value}
              onClick={option.action}
            >
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CustomDropdown;
